import React from "react"
import { connect } from 'react-redux';
import _ from 'lodash';
import SheetsWrapper from "./index.js"
import moment from 'moment';
import {formatPData} from "../../helpers/dataHelpers";

class SheetsDataWrapper extends React.Component{
    constructor(props){
      super(props)
      this.getData = this.getData.bind(this)
    }

    section(title, header, rows, columns) {
      let section = {}
      section["title"] = title
      section["header"] = header
      section["rows"] = rows
      section["columns"] = columns
      return section
    }

    titleSection(data) {
      const date = moment().format("YYYY-MM-DD")
      const title = "Telescope Data Export"
      const header = {
        "type": "big-list"
      }
      const rows = [{
          "type": "header",
          "values": ["Customer Name", "", "Updated"]
        },
        {
          "type": "content",
          "values": [(this.props.user.userProfile && this.props.user.userProfile.client), "", date]
        }
      ]
      const columns = [{
        "type": "header"
      }]

      return this.section(title, header, rows, columns)
    }

    getDates(data) {
      const brandAwarenessTime = this.props.data && this.props.data.brandAwarenessData;
      let dates = []
      _.each(brandAwarenessTime, function(o,i) {
        dates.push(o.date)
      })
      return dates
    }

    generalSection(data) {
      const brandAwarenessTime = this.props.data && this.props.data.brandAwarenessData;
      const brandConsiderationTime = this.props.data && this.props.data.brandConsiderationData;
      let dates = []
      let awarenessValues = ["Awareness"]
      let considerationValues = ["Consideration"]
      let relevanceValues = ["Relevance"]
      let targetValues = ["Target"]

      data.relevanceData && data.relevanceData.data && data.relevanceData.data.forEach(function(o,i) {
        relevanceValues.push(o.rlv && parseFloat(o.rlv.nscore).toFixed(2))
      })

      const numberOfValues = relevanceValues.length - 1

      for (var i=0;i<numberOfValues;i++) {
        targetValues.push(this.props.data.variableData.targetScore)
      }

      _.each(brandAwarenessTime, function(o,i) {
        dates.push(o.date)
        awarenessValues.push(o.value && parseFloat(o.value.yes).toFixed(2))

        if (brandConsiderationTime && brandConsiderationTime[i]) {
          considerationValues.push(brandConsiderationTime[i].value && parseFloat(brandConsiderationTime[i].value.yes).toFixed(2))
        }
      });

      const title = "GENERAL"
      const header = {
        "type": "time-series",
        "values": dates
      }
      const rows = [{
          "type": "content",
          "values": awarenessValues
        },
        {
          "type": "content",
          "values": considerationValues
        },
        {
          "type": "content",
          "values": relevanceValues
        },
        {
          "type": "content",
          "values": targetValues
        }
      ]
      const columns = [{
        "type": "header"
      }]

      return this.section(title, header, rows, columns)
    }

    suggestedRecommendation(property, data, title = "SUGGESTED RECOMMENDATION") {
      const header = {
        "type": "list"
      }

      const columns = [{
        "type": "header"
      }]

      let sentimentSettings = this.props.user.client && this.props.user.client.sentimentSettings;
      let paramSentiment = _.filter(sentimentSettings, function(row, i) {
        return row[0].value === property
      })

      let dummyRow = {
        type: "content", //(count %2 === 0) ? "header" : "content",
        bold: false, //(count %2 === 0),
        values: [" "," "," "," "," "]
      }

      if (!paramSentiment || !paramSentiment.length) {
        const rows=[dummyRow, dummyRow, dummyRow, dummyRow, dummyRow, dummyRow]
        return this.section(title, header, rows, columns)
      }

      let keywords = [];

      // Make array into object
      let hints = [];
      _.each(paramSentiment, function(row, i) {
        let hint = {};
        _.each(row, function(col,i) {
          hint[col.type] = col.value
        });
        hints.push(hint);
      })

      let recommendations = {};
      _.each(hints, function(hint, i) {
        let keywordHints = recommendations[hint.keyword] && recommendations[hint.keyword].hints || [];
        keywordHints.push({title: hint.hint, weight: hint.weight});
        recommendations[hint.keyword] = recommendations[hint.keyword] || {};
        recommendations[hint.keyword].hints = keywordHints;
      })

      let rows = []

      for (var key in recommendations) {
        if (recommendations.hasOwnProperty(key)) {
          let words = [key]
          let values = [""]

          let hints = recommendations[key].hints
          let total = 0
          hints.forEach(function(o,i) {
            total += parseFloat(o.weight)
          })

          hints.forEach(function(o,i) {
            words.push(o.title)
            const weight = parseInt((o.weight / total) * 100) + "%"
            values.push(weight)
          })

          let textRow = {
            type: "content", //(count %2 === 0) ? "header" : "content",
            bold: false, //(count %2 === 0),
            values: words
          }
          let numbersRow = {
            values: values
          }

          rows.push(textRow)
          rows.push(numbersRow)
        }
      }

      let numberOfRowsToShow = 6
      let rowAdjustmentCount = rows.length - numberOfRowsToShow

      if (rowAdjustmentCount > 0) {
        rows = _.dropRight(rows, rowAdjustmentCount)
      } else if (rowAdjustmentCount < 0) {
        const n = Math.abs(rowAdjustmentCount)
        for (var i=0;i<n;i++) {
          rows.push(dummyRow)
        }
      }

      return this.section(title, header, rows, columns)
    }

    kpiPyramid(data, user) {
      const title = "KPI PYRAMID"
      const columns = [{
          "type": "header"
      }]
      const header = {
          "type": "list",
          "values": ["Current", "Target"]
      }
      const targetArray = user.client && user.client.targetSettings;

      // Make array into object
      let targets = {};
      _.each(targetArray, function(row, i) {
        let obj = {};
        let param = '';
        _.each(row, function(col,i) {
          obj[col.type] = col.value
          if (col.type==='param') {
            param = col.value;
          }
        });
        targets[param] = obj;
      })
      const brandData = (data && data.variableData && data.variableData.brand) || {};
      const brandAwareness = brandData.awareness && brandData.awareness.yes ?  (brandData.awareness.yes + "%") : "N/A";
      const preference = data.telescope && data.telescope._data.prf && data.telescope._data.prf.perception && data.telescope._data.prf.perception.positive ? (data.telescope._data.prf.perception.positive + "%") : "N/A";

      const targetMarketShare = (targets.marketShare && targets.marketShare.target) ?  (targets.marketShare && targets.marketShare.target) + (targets.marketShare && targets.marketShare.unit) : 'N/A'
      const targetSov = (targets.shareOfVoice && targets.shareOfVoice.target) ? (targets.shareOfVoice && targets.shareOfVoice.target) + (targets.shareOfVoice && targets.shareOfVoice.unit) : 'N/A'
      const targetBrandAwe = (targets.brandAwareness && targets.brandAwareness.target) ? (targets.brandAwareness && targets.brandAwareness.target) + (targets.brandAwareness && targets.brandAwareness.unit) : 'N/A'
      const targetPref =  (targets.preference && targets.preference.target) ? (targets.preference && targets.preference.target) + (targets.preference && targets.preference.unit) : 'N/A'
      const targetTraffic = (targets.traffic && targets.traffic.target) ? (targets.traffic && targets.traffic.target) + (targets.traffic && targets.traffic.unit) : 'N/A'

      const rows = [{
          "type": "content",
          "values": ["Market Share", "N/A", targetMarketShare]
        },
        {
          "type": "content",
          "values": ["Share of voice", "N/A", (targets.shareOfVoice && targets.shareOfVoice.target) + (targets.shareOfVoice && targets.shareOfVoice.unit)]
        },
        {
          "type": "content",
          "values": ["Brand awareness", brandAwareness, targetBrandAwe]
        },
        {
          "type": "content",
          "values": ["Preference", preference, targetPref]
        },
        {
          "type": "content",
          "values": ["Traffic (New visits)", "N/A", targetTraffic]
        }
      ]

      // Add client specific KPIs
      let clientViewSettings = (this.props.user.client && this.props.user.client.viewSettings) || {};
      const datapoints = [
        {
          id: "newSubscriptions",
          label: "New subscriptions"
        },
        {
          id: "result",
          label: "RESULT"
        }
      ];

      let usedAllRows = false

      _.each(datapoints, function(dp, i) {
        if (clientViewSettings[dp.id]) {
          let year = data.endDate.getFullYear();
          let month = data.endDate.getMonth() + 1;
          let results = data[dp.id]

          if (results) {
            let result = (results[year] && results[year][month]) || "N/A"

            const row = {
              "type": "content",
              "values": [dp.label, result, (targets[dp.id] || "N/A")]
            }
            if (!usedAllRows) {
              rows.push(row)
            }
            usedAllRows = true
          }
        }
      })

      if (!usedAllRows) {
        const row = {
          "type": "content",
          "values": ["", "", ""]
        }

        rows.push(row)
      }


      return this.section(title, header, rows, columns)
    }

    socialMediaChannels(data, user) {
      const title = "SOCIAL MEDIA CHANNELS"
      const header = {
        "type": "list",
        "values": ["Share"]
      }

      const channels = this.props.data && this.props.data.telescope && this.props.data.telescope._data && this.props.data.telescope._data.prm && this.props.data.telescope._data.prm.channels;
      const channelItems = [];
      let total = 0;
      for (var channel in channels) {
        if (channels.hasOwnProperty(channel)) {
          total = parseInt(total, 10) + parseInt(channels[channel], 10);
        }
      }
      for (var channel in channels) {
        if (channels.hasOwnProperty(channel)) {
          let channelName = channel;

          switch (channelName) {
            case 'social_reviews':
             channelName = 'Reviews';
             break;
           case 'social_blogs':
            channelName = 'Blogs';
            break;
          case 'social_comments':
             channelName = 'Social comments';
             break;
          case 'social_message_boards':
            channelName = 'Forums';
            break;
          }

          channelItems.push({
            "type": "content",
            "values": [channelName, parseInt(parseInt(channels[channel], 10) / parseInt(total, 10) * 100, 10) + "%"]
          })
        }
      }

      let rows = channelItems

      const columns = [{
          "type": "header"
      }]

      let numberOfRowsToShow = 5
      let rowAdjustmentCount = rows.length - numberOfRowsToShow
      let dummyRow={
        "type": "content",
        "values": [" ", " "]
      }

      if (rowAdjustmentCount > 0) {
        rows = _.dropRight(rows, rowAdjustmentCount)
      } else if (rowAdjustmentCount < 0) {
        const n = Math.abs(rowAdjustmentCount)
        for (var i=0;i<n;i++) {
          rows.push(dummyRow)
        }
      }

      return this.section(title, header, rows, columns)
    }

    shareOfVoice(data) {
      const title = "SHARE OF VOICE"
      const brandData = (data && data.variableData && data.variableData.brand) || {};
      const columns = [{
        "type": "header"
      }]
      let header = {
        "type": "list",
      }
      let brands = []
      let values = ["Share of voice"]
      let rows = []

      const sov = brandData.sov
      for (var brand in sov) {
        if (sov.hasOwnProperty(brand)) {
          brands.push(brand[0].toUpperCase() + brand.substring(1))
          values.push(parseInt(sov[brand], 10) + "%")
        }
      }

      header["values"] = brands
      rows.push({
        "type": "content",
        "values": values
      })

      return this.section(title, header, rows, columns)
    }

    keyAreas(data) {
      const title = "CATEGORY KEY AREAS"
      const columns = [{
        "type": "header"
      }]
      let header = {
        "type": "list",
      }
      let rows = []
      let variables = (data.variableData && data.variableData.variables) || []
      variables = _.orderBy(variables, 'potential', 'desc')
      header["values"] = [variables[0].name, variables[1].name, variables[2].name]

      rows.push({
        "type": "content",
        "values": ["Impact", variables[0].impact, variables[1].impact, variables[2].impact]
      })

      rows.push({
        "type": "content",
        "values": ["Potential", variables[0].potential, variables[1].potential, variables[2].potential, ]
      })

      const section = this.section(title, header, rows, columns)
      return section
    }

    brandRelevance(data) {
      const title = "BRAND RELEVANCE"
      let header = {
        "type": "list",
      }
      const columns = [{
        "type": "header"
      }]

      let rows = []
      let brands = []
      let score = data.variableData.nscore || data.variableData.score || 0

      if (data.variableData.nscore === 0) {
        score = data.variableData.nscore
      }

      let values = ["Relevance"]

      score = parseFloat(score).toFixed(2);
      const target = data.variableData.targetScore ? parseFloat(data.variableData.targetScore).toFixed(2) : null
      const index = data.variableData.index ? parseFloat(data.variableData.index).toFixed(2) : null
      const relevanceData = data.variableData.brand && data.variableData.brand.relevance || {}
      const competitors = []
      for (var brand in relevanceData) {
        brands.push(brand[0].toUpperCase() + brand.substring(1))
        values.push(parseFloat(relevanceData[brand]).toFixed(2))
      }

      rows.push({
        "type": "content",
        "values": values
      })

      rows.push({
        "type": "content",
        "values": ["Target", target]
      })

      header["values"] = brands

      return this.section(title, header, rows, columns)
    }

    pSection(p, historicData, dates) {
      const _this = this
      const title = p.name && p.name.toUpperCase()
      let datapoints = []

      _.each(historicData, function(dp, i) {
        const variables = dp.variables
        let varData = {}

        _.each(variables, function(v, i) {
          if (v.id === p.id) {
            varData = v
          }
        })

        const datapoint = {
          date: dp.date,
          value: varData.nscore == null ? '' : parseFloat(varData.nscore).toFixed(2),
          target: varData.target == null ? '' : varData.target,
          impact: varData.impact == null ? '' : varData.impact + "%",
          potential: varData.potential == null ? '' : parseFloat(varData.potential).toFixed(2),
        }

        const corrs = varData.correlations
        if (corrs) {
          for (var key in corrs) {
            if (corrs.hasOwnProperty(key)) {
              datapoint[key] = corrs[key]
            }
          }
        }
        datapoints.push(datapoint)
      })

      const values = {
        date: [],
        value: ["Value [float]"],
        target: ["Target [float 0-10]"],
        impact: ["Impact [% 0-1]"],
        potential: ["Potential [float:-1,1]"],
        correlation: ["Correlation to other P's"],
        prc: ["Price"],
        prd: ["Product"],
        prm: ["Promotion"],
        prp: ["Proposal"],
        ppl: ["People"],
        prf: ["Preference"],
        plc: ["Place"]
      }

      values[p.apiId] = null
      delete values[p.apiId]

      _.each(datapoints, function(dp, i) {
        for (var key in dp) {
          if (dp.hasOwnProperty(key) && values.hasOwnProperty(key)) {
            let val = dp[key]

            // Validate format
            switch(key) {
              case 'date':

              break
              case 'impact':

              break
              default:
                if (key != 'date' && isNaN(val)) {
                  val = ''
                }
              break
            }

            values[key].push(val)
          }
        }
      })
      const header = {
        "type": "time-series",
        "values": values.date
      }

      const columns = [{
        "type": "header"
      }]

      let rows = []
      let skipRows = ["date"]

      for (var key in values) {
        if (values.hasOwnProperty(key) && skipRows.indexOf(key) === -1) {
          rows.push({
            "type": "content",
            "values": values[key]
          })
        }
      }

      return this.section(title, header, rows, columns)
    }

    async getDataForDate(ts, date) {
      let promise = new Promise((resolve, reject) => {
          ts.date = moment().format(date)
          ts.on('data', data => {
            resolve(data)
          })
      });

      let result = await promise
      return result
    }

    async getHistoricData(dates){
      let Telescope = window.Telescope;
      const ts = new Telescope({brand: this.props.user.userProfile.client});
      let datasets = {}
      //ts.sync().then(() => {
        for (const date of dates) {
          await this.getDataForDate(ts, date).then(data => {
            datasets[date] = formatPData(data, this.props)
          })
        }
      //}

      return datasets
    }

    async buildPSections(data, dates) {
      let variables = (data.variableData && data.variableData.variables) || []
      const order = ["prc", "prd", "prm", "prp", "ppl", "prf", "plc"]
      variables = _.sortBy(variables, function(item){
        return order.indexOf(item.apiId)
      })
      const skipVars = ["rlv", 'plc']
      const disabledVars = [{id:'place', apiId:'plc', name:'Place'}]


      const _this = this
      let pSections = []
      //dates = ["2018-01-01"]
      await this.getHistoricData(dates).then(historicData => {
        _.each(variables, function(p, i) {
          if (skipVars.indexOf(p.apiId) === -1) {
            pSections.push(_this.pSection(p, historicData, dates))
            const recommendationsSection = _this.suggestedRecommendation(p.id, data, "RECOMMENDATION")
            if (recommendationsSection) {
              pSections.push(recommendationsSection)
            } else {
              const dummyRecommendationsSection = _this.suggestedRecommendation('dummy', data, "RECOMMENDATION")
              pSections.push(dummyRecommendationsSection)
            }
          }
        })

        _.each(disabledVars, function(p, i) {
          pSections.push(_this.pSection(p, historicData, dates))
          const dummyRecommendationsSection = _this.suggestedRecommendation('dummy', data, "RECOMMENDATION")
          pSections.push(dummyRecommendationsSection)
        })
      })

      console.log("Built P sections")
      return pSections
    }

    async getData() {
      const data = this.props.data
      const user = this.props.user
      if (!data || !user) {
        return
      }

      const dates = this.getDates(data)
      const highestPotentialVar = data.sentimentData && data.sentimentData.highestPotentialVar && data.sentimentData.highestPotentialVar.id;
      let sections = []

      sections.push(this.titleSection(data))
      sections.push(this.generalSection(data))
      this.suggestedRecommendation(highestPotentialVar, data) ? sections.push(this.suggestedRecommendation(highestPotentialVar, data)) : null
      sections.push(this.kpiPyramid(data, user))
      sections.push(this.socialMediaChannels(data, user))
      sections.push(this.shareOfVoice(data, user))
      sections.push(this.brandRelevance(data))

      const pSections = await this.buildPSections(data, dates)

      sections.push(...pSections)
      sections.push(this.keyAreas(data))

      return {title: "Telescope Data Export", sections: sections}
    }

    render(){
        return (
          <SheetsWrapper getData={this.getData} data={this.props.data}/>
        )
    }
}


function mapStateToProps(state, ownProps) {
    return {
      data: state.data,
      user: state.user
    };
}

export default connect(mapStateToProps, {})(SheetsDataWrapper);



// WEBPACK FOOTER //
// ./src/components/export-google-sheet/SheetsDataWrapper.js